"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _CreditInfo = _interopRequireDefault(require("./CreditInfo"));

require("../styles/_payment-options.scss");

var MESSAGE_NO_PURCHASE_ORDER = "If you do not have a Purchase Order Number, simply hit 'Confirm' and our Finance Team will get back to you with your invoice.";

function PaymentOptions(a) {
  var b = a.updatePurchaseOrderId,
      c = a.showCreditInfo,
      d = a.orgCreditInfo,
      e = a.teamCreditInfo,
      f = a.totalCost,
      g = a.getCurrencySymbol,
      h = a.isSaveDisabled,
      i = a.onSelectTeam;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_uiKit.Text, {
    heading5: !0
  }, "Payment Options"), _react["default"].createElement("div", {
    className: "payment-options__body"
  }, c && _react["default"].createElement(_CreditInfo["default"], {
    teamCreditInfo: e,
    orgCreditInfo: d,
    onSelectTeam: i
  }), _react["default"].createElement(_uiKit.RadioButton, {
    selected: !0
  }, "Request Invoice"), _react["default"].createElement("hr", {
    className: "payment-options__body__horizontal-line"
  }), _react["default"].createElement(_uiKit.Input, {
    label: "Purchase order number",
    placeholder: "Enter number",
    onChange: b
  }), _react["default"].createElement("div", {
    className: "payment-options__body__footer"
  }, _react["default"].createElement(_uiKit.Text, {
    label: !0,
    noMargin: !0
  }, MESSAGE_NO_PURCHASE_ORDER)), _react["default"].createElement("hr", {
    className: "payment-options__body__horizontal-line"
  }), _react["default"].createElement("div", {
    className: "total-summary__content"
  }, _react["default"].createElement("div", null, _react["default"].createElement(_uiKit.Text, {
    noMargin: !0
  }, "Total Cost"), _react["default"].createElement(_uiKit.Text, {
    caption: !0,
    noMargin: !0
  }, "(incl. Tax)")), _react["default"].createElement("div", {
    className: "total-summary__content__cost"
  }, _react["default"].createElement(_uiKit.Text, {
    heading5: !0,
    noMargin: !0
  }, "".concat(g()).concat(f, " ").concat(c && !h ? " + 1 credit" : ""))))));
}

var _default = (0, _react.memo)(PaymentOptions);

exports["default"] = _default;